/**
 * RouteFallback — Suspense fallback for lazy-loaded routes. Renders the
 * `route` variant of `BrandReveal`: the mark in a teal-to-sand orbit ring on
 * the page canvas.
 */

import { BrandReveal } from "@/components/brand/BrandReveal";

export function RouteFallback() {
  return <BrandReveal variant="route" />;
}
